<table
  class="comp table-striped borderless"
  width="100%"
  cellspacing="0"
  border="0"
  (mouseleave)="rowHovered(null)"
>
  <tbody>
    <tr
      *ngFor="let school of values(schools); let i = index"
      [ngClass]="{ hoveredRow: bodyRowHoveredIndex == i }"
      (mouseover)="rowHovered(i)"
    >
      <td class="name-col comp">
        <div *ngIf="school && school['hasPermissionToView'] === false">
          <span class="name-text">{{ school["officialSchoolName"] }}</span>
        </div>
        <div
          *ngIf="school && school['hasPermissionToView'] === true"
          class="comp-link"
        >
          <a
            [routerLink]="'/profile/school/' + school['systemSchoolId']"
            (click)="setTitle('School Profile')"
            class="comp-link"
            >{{ school["officialSchoolName"] }}</a
          >
        </div>
      </td>
    </tr>
  </tbody>
</table>
